import { useEffect } from 'react';
import {
  ALL_TABS,
  NON_JPEQ_TABS,
  SYMBOL_DETAIL_TABS
} from '../../constants/symbolDetailsTabs';
import useLocalize from '../../utils/hooks/useLocalize';
import useSymbolMetadata from '../../utils/hooks/useSymbolMetadata';
import { isJpeq } from '../../utils/symbol';
import NewsTabComponent from './NewsTabComponent/NewsTabComponent';
import SummaryTabComponent from './SummaryTabComponent/SummaryTabComponent';
import './TabComponent.scss';

export const TabComponent = ({ mode, setMode, symbol }) => {
  const localize = useLocalize();
  const symbolMetadata = useSymbolMetadata(symbol);
  const isJpeqSymbol = isJpeq(symbolMetadata.assetClass);

  const tabs = isJpeqSymbol ? ALL_TABS : NON_JPEQ_TABS;

  // Reset mode when current mode is not available
  useEffect(() => {
    if (!tabs.includes(mode)) {
      setMode(tabs[0]);
    }
  }, [mode, tabs, setMode]);

  return (
    <div>
      <div className="tab-container">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setMode(tab)}
            className={`tab-button${mode === tab ? ' active' : ''}`}
            data-testid={`tab-button-${tab}`}
          >
            {localize(`symbol.details.tab.${tab}`)}
          </button>
        ))}
      </div>
      <div>
        {mode === SYMBOL_DETAIL_TABS.SUMMARY && (
          <SummaryTabComponent symbol={symbol} />
        )}
        {mode === SYMBOL_DETAIL_TABS.INDICATORS && (
          <div data-testid="tab-content-indicators">
            indicators content goes here.
          </div>
        )}
        {mode === SYMBOL_DETAIL_TABS.CHART && (
          <div data-testid="tab-content-chart">Chart content goes here.</div>
        )}
        {mode === SYMBOL_DETAIL_TABS.NEWS && (
          <NewsTabComponent symbol={symbol} newsPerPage={25} />
        )}
        {mode === SYMBOL_DETAIL_TABS.HISTORICAL && (
          <div data-testid="tab-content-historical">
            historical content goes here.
          </div>
        )}
      </div>
    </div>
  );
};
